import React from 'react';
import Selectors from '@/vocabularies/hooks/selectors';
import PartnerLogo from '@/components/navbar/PartnerLogo';

const PartnerLink = () => {
  const { href, title } = Selectors.usePartnerLink();
  if (!href) {
    return null;
  }
  return (
    <a href={href} target="_partnerlink" rel="noopener noreferrer" className="header item aridhia-partner-logo">
      <PartnerLogo title={title} />
    </a>
  );
};

export default PartnerLink;
